@if (isPrerender) {
<!-- Durante prerender, mostrar contenido estático -->
<ng-container *ngTemplateOutlet="prerenderTemplate"></ng-container>
} @else if (loading()) {
<!-- Durante carga normal -->
<ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
} @else {
<!-- Products List -->
@if (products().length > 0) {
<allas-product-list
  [h1DescriptionTitle]="h1DescriptionTitle"
  [productsFetchedByVehicle]="productsFetchedByVehicle()"
  [defaultVehicleAlias]="defaultVehicleAlias()"
  [products]="products()"
  [categoryName]="categoryName()"
  [marcaVehiculo]="marcaVehiculo()"
  [modeloVehiculo]="modeloVehiculo()"
  [anioVehiculo]="anioVehiculo()"
/>
} @else {
<ng-container *ngTemplateOutlet="noProductsTemplate"></ng-container>
} }

<!-- Loading Template -->
<ng-template #loadingTemplate>
  <div class="w-full mb-2 mt-6">
    <p-skeleton class="w-full" height="150px"></p-skeleton>
  </div>
  <section class="min-h-screen flex gap-2 mb-6">
    <div class="w-2/6 h-full">
      <p-skeleton class="w-full h-full" height="1224px"></p-skeleton>
    </div>
    <div class="w-4/6 grid gap-2 grid-cols-1 xl:grid-cols-3 h-full">
      @for (skeleton of skeletons; track skeleton) {
      <p-skeleton class="w-full" height="300px"></p-skeleton>
      }
    </div>
  </section>
</ng-template>

<!-- Prerender Template -->
<ng-template #prerenderTemplate>
  <!-- Header -->
  <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>

  <!-- Body -->
  <div class="text-center py-16 mb-12">
    <div class="max-w-md mx-auto">
      <div class="text-6xl mb-6">🔧</div>
      <h2 class="text-3xl font-bold text-gray-900 mb-4">
        {{ currentCategory()?.name || "Repuestos para carro" }}
        <!---->
        @if( marca()) { de la marca {{ marca() }} }
        <!---->
        @if (marcaVehiculo()) { para
        {{ marcaVehiculo() }} {{ modeloVehiculo() }} {{ anioVehiculo() }}
        }
      </h2>
      <p class="text-gray-600 mb-6 text-lg">
        Encontrá los mejores repuestos para tu carro.
      </p>

      <div
        class="bg-appPrimary-50 border border-appPrimary-200 rounded-xl p-6 mb-6"
      >
        <h2 class="text-appPrimary-500 font-semibold text-xl mb-3">
          Repuestos para carro de Calidad
        </h2>
        <p class="text-appPrimary-500 mb-4">
          Amplia selección de repuestos para carro con garantía y envío gratis
        </p>
        <div class="text-left text-sm text-appPrimary-500 space-y-2">
          <div class="flex items-center space-x-2">
            <span class="text-appPrimary-500">✓</span>
            <span>Garantía en todos los productos</span>
          </div>
          <div class="flex items-center space-x-2">
            <span class="text-appPrimary-500">✓</span>
            <span>Instalación profesional</span>
          </div>
          <div class="flex items-center space-x-2">
            <span class="text-appPrimary-500">✓</span>
            <span>Envío gratis a domicilio</span>
          </div>
          <div class="flex items-center space-x-2">
            <span class="text-appPrimary-500">✓</span>
            <span>Precios competitivos</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- No Products Found Template -->
<ng-template #noProductsTemplate>
  <!-- Coming Soon -->
  <div class="text-center py-16 mb-12">
    <div class="max-w-md mx-auto">
      <div class="text-6xl mb-6">🔧</div>
      <h2 class="text-3xl font-bold text-gray-900 mb-4">
        @if (currentCategory()?.name) {
        <!---->
        {{ currentCategory()?.name || "" }}
        <!---->
        @if (marcaVehiculo()) {
        <!---->
        para {{ marcaVehiculo() }} {{ modeloVehiculo() }} {{ anioVehiculo() }}
        <!---->
        } @else {
        <!---->
        para carro
        <!---->
        }
        <!---->
        }
      </h2>
      <p class="text-gray-600 mb-6 text-lg">
        Agrega esta categoría a tu carrito de cotización para recibir
        información personalizada
      </p>

      <!-- Botón de Agregar al Carrito -->
      <div class="mb-6">
        @if (cartService.isItemInCart(currentCategory()?.id || 0)) {
        <!-- Ya está en el carrito -->
        <div class="bg-green-50 border border-green-200 rounded-xl p-4 mb-4">
          <div
            class="flex items-center justify-center space-x-2 text-green-700"
          >
            <span class="font-medium">Ya está en tu carrito</span>
          </div>
        </div>
        <button
          (click)="increaseCartQuantity()"
          class="w-full bg-appPrimary-500 hover:bg-blue-700 text-white py-3 px-6 rounded-lg font-semibold transition-colors flex items-center justify-center space-x-2"
        >
          <span>Agregar más cantidad</span>
        </button>
        } @else {
        <!-- Agregar al carrito -->
        <button
          (click)="addToCart()"
          [disabled]="addingToCart()"
          class="w-full bg-appPrimary-500 hover:bg-blue-700 disabled:bg-blue-400 text-white py-4 px-6 rounded-lg font-semibold transition-colors flex items-center justify-center space-x-3 text-lg"
        >
          @if (addingToCart()) {
          <div
            class="animate-spin rounded-full h-5 w-5 border-b-2 border-white"
          ></div>
          <span>Agregando...</span>
          } @else {
          <span>Agregar al Carrito de Cotización</span>
          }
        </button>
        }
      </div>

      <div class="bg-blue-50 border border-blue-200 rounded-xl p-6 mb-6">
        <h3 class="text-blue-800 font-semibold text-xl mb-3">
          Cotización Personalizada
        </h3>
        <p class="text-blue-600 mb-4">
          Nuestros expertos te ayudarán a encontrar exactamente lo que necesitas
        </p>
        <div class="text-left text-sm text-blue-700 space-y-2">
          <div class="flex items-center space-x-2">
            <span class="text-blue-500">✓</span>
            <span>Asesoría técnica especializada</span>
          </div>
          <div class="flex items-center space-x-2">
            <span class="text-blue-500">✓</span>
            <span>Precios competitivos al mayoreo</span>
          </div>
          <div class="flex items-center space-x-2">
            <span class="text-blue-500">✓</span>
            <span>Disponibilidad y entrega inmediata</span>
          </div>
          <div class="flex items-center space-x-2">
            <span class="text-blue-500">✓</span>
            <span>Garantía en todos los productos</span>
          </div>
        </div>
      </div>
      <div class="space-y-3">
        <p class="text-gray-500">¿Necesitas este producto ahora?</p>
        <div class="flex flex-col sm:flex-row gap-3 justify-center">
          <a
            href="tel:+50422834540"
            class="inline-flex items-center justify-center px-6 py-3 bg-red-600 text-white font-semibold rounded-lg hover:bg-red-700 transition-colors"
          >
            <span class="mr-2">📞</span>
            Llamar Ahora
          </a>
          <a
            href="https://wa.me/50422834540"
            target="_blank"
            class="inline-flex items-center justify-center px-6 py-3 bg-green-600 text-white font-semibold rounded-lg hover:bg-green-700 transition-colors"
          >
            <span class="mr-2">💬</span>
            WhatsApp
          </a>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #headerTemplate>
  <header class="mb-8">
    <h2 class="text-3xl font-bold text-gray-900 mb-2">
      {{ currentCategory()?.name || "Productos" }}
      @if (marcaVehiculo()) { para {{ marcaVehiculo() }} {{ modeloVehiculo() }}
      {{ anioVehiculo() }}
      }
    </h2>
  </header>
</ng-template>
